var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 0.166748C2.78002 0.166748 0.166687 2.78008 0.166687 6.00008C0.166687 9.22008 2.78002 11.8334 6.00002 11.8334C9.22002 11.8334 11.8334 9.22008 11.8334 6.00008C11.8334 2.78008 9.22002 0.166748 6.00002 0.166748ZM4.41919 8.50258L2.32502 6.40841C2.09752 6.18091 2.09752 5.81341 2.32502 5.58591C2.55252 5.35841 2.92002 5.35841 3.14752 5.58591L4.83335 7.26591L8.84669 3.25258C9.07419 3.02508 9.44169 3.02508 9.66919 3.25258C9.89669 3.48008 9.89669 3.84758 9.66919 4.07508L5.24169 8.50258C5.02002 8.73008 4.64669 8.73008 4.41919 8.50258Z",
    fill: "#FEF6F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2821763c152790a857c132d3f11a27f1.svg";
export { ForwardRef as ReactComponent };